<template>
  <div>
    <slot
      :empty-suggestions="emptySuggestionsDelayed"
      :fetch-suggestions="fetchSuggestionsIfNeeded"
    />
    <div class="suggestions-wrapper">
      <ul v-if="suggestions && suggestions.length" class="suggestions">
        <li
          v-for="suggestion in suggestions"
          @click="suggestionSelected(suggestion)"
        >
          {{ suggestion.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/* TODO: Add proper typing to resolve type safety warnings */

import FetchLocationCampsiteSuggestions from '~/apps/search-wizard/campsites-search/location/infrastructure/FetchLocationCampsiteSuggestions'
import { LocationSuggestionCampsite } from '~/apps/search-wizard/campsites-search/location/domain/LocationSuggestions'
import { debounce } from 'lodash-es'
const { i18n } = useI18n()

const campsiteName = defineModel({ default: '' })

const campsiteSearch = new FetchLocationCampsiteSuggestions()
const suggestions = ref<Array<LocationSuggestionCampsite>>([])

watch(campsiteName, async () => {
  await fetchSuggestionsIfNeeded()
})

async function fetchSuggestionsIfNeeded() {
  if (campsiteName.value.length < 3) {
    suggestions.value = []
    return
  }
  await debouncedFetchSuggestions(campsiteName.value)
}

const debouncedFetchSuggestions = debounce(fetchSuggestions, 300)

async function fetchSuggestions(searchString) {
  suggestions.value = await campsiteSearch.fetch(searchString, i18n.locale)
}

function suggestionSelected(suggestion) {
  campsiteName.value = suggestion.name
  emptySuggestions()
}

const emptySuggestionsDelayed = debounce(emptySuggestions, 300)

function emptySuggestions() {
  suggestions.value = []
}
</script>

<style scoped>
.suggestions-wrapper {
  position: relative;
  top: -1em;
}

.suggestions {
  position: absolute;
  background: white;
  width: 100%;
  padding: 0.5em;
  z-index: 9999;
}

.suggestions li {
  margin: 0.5em;
  cursor: pointer;
}
</style>
